import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { longtailSetupStatus } from '~constants';
import generatePath from '~settings/routing';

export default class LongtailPaymentSetupStatus extends React.Component {
  constructor() {
    super();

    this.routingMapping = {
      'initial-setup': 'paymentInitialSetup',
      deposit: 'paymentDeposit',
      fee: 'paymentFee',
      'rent-payment': 'paymentRentPayment',
      'enable-payments': 'paymentEnablePayments',
    };
  }

  clickable = status => {
    if (this.props.disableInteraction) {
      return false;
    }

    if (this.props.currentStep === status) {
      return false;
    }

    switch (status) {
      case 'initial-setup':
      case 'deposit':
      case 'fee':
      case 'rent-payment':
      case 'enable-payments':
        return !!this.props.paymentPlan;
      default:
        return false;
    }
  };

  configured = status => {
    switch (status) {
      case 'initial-setup':
        return true;
      case 'deposit':
      case 'fee':
      case 'rent-payment':
      case 'enable-payments':
        return !!this.props.paymentPlan;
      default:
        return false;
    }
  };

  handleItemClick = status => {
    if (this.clickable(status) && this.props.paymentPlan) {
      const targetUrl = this.routingMapping[status];
      if (this.props.currentStep === 'initial-setup') {
        this.props.handleInitialSetup(status);
      } else {
        this.props.push(generatePath(targetUrl, {}, { id: this.props.paymentPlan.id }));
      }
    }
  };

  render() {
    return (
      <ul className="long-tail-payment__status" role="menu">
        <For each="status" of={longtailSetupStatus}>
          <li
            key={status}
            role="menuitem"
            className={classNames(
              'long-tail-payment__status__item',
              `long-tail-payment__status__item--${status}`,
              {
                active: this.props.currentStep === status,
                configured: this.configured(status),
                clickable: this.clickable(status),
              },
            )}
            onClick={() => {
              this.handleItemClick(status);
            }}
          >
            <span className="long-tail-payment__status__circle" />
            <span className="long-tail-payment__status__label">
              {this.props.t(`landlord.payment.setup_status.${status.replace(/-/g, '_')}`)}
            </span>
          </li>
        </For>
      </ul>
    );
  }
}

LongtailPaymentSetupStatus.propTypes = {
  disableInteraction: PropTypes.bool,
  currentStep: PropTypes.string.isRequired,
  push: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  paymentPlan: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  handleInitialSetup: PropTypes.func.isRequired,
};

LongtailPaymentSetupStatus.defaultProps = {
  disableInteraction: false,
  currentStep: '',
  push: () => {},
  t: () => {},
  paymentPlan: null,
};
